"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.parse = void 0;
const tslib_1 = require("tslib");
//@ts-ignore
const clarinet_1 = tslib_1.__importDefault(require("clarinet"));
function parse(input) {
    const gen = processNode();
    let out = undefined;
    let err = undefined;
    function dispatch(obj) {
        try {
            const res = gen.next(obj);
            if (res.done)
                out = res.value;
        }
        catch (e) {
            err = e;
        }
    }
    const p = clarinet_1.default.parser();
    p.onopenobject = (key) => dispatch({ type: 'openobject', key });
    p.onopenarray = () => dispatch({ type: 'openarray' });
    p.onkey = (key) => dispatch({ type: 'key', key });
    p.onvalue = (value) => dispatch({ type: 'value', value });
    p.oncloseobject = () => dispatch({ type: 'closeobject' });
    p.onclosearray = () => dispatch({ type: 'closearray' });
    p.onerror = (err) => dispatch({ type: 'error', err });
    //p.onend = () => dispatch({type:'end'});
    gen.next();
    p.write(input).close();
    if (err)
        throw err;
    return out;
}
exports.parse = parse;
function stringify(obj) {
    if (Array.isArray(obj))
        return `[${obj.map(stringify).join(',')}]`;
    if (obj instanceof Map)
        return `{${[...obj]
            .map(([k, v]) => JSON.stringify(k) + ':' + stringify(v))
            .join(',')}}`;
    return JSON.stringify(obj);
}
exports.stringify = stringify;
const CLOSE_ARRAY = Symbol();
function* processNode() {
    const evt = yield;
    switch (evt.type) {
        case 'value':
            return evt.value;
        case 'openobject':
            const obj = new Map();
            let key = evt.key;
            if (key === undefined)
                yield; // must be 'objectclose'
            while (key !== undefined) {
                obj.set(key, (yield* processNode()));
                key = (yield).key; // 'key' or 'objectclose' event
            }
            return obj;
        case 'openarray':
            const arr = [];
            let el;
            while (true) {
                el = yield* processNode();
                if (el === CLOSE_ARRAY)
                    return arr;
                arr.push(el);
            }
        case 'closearray':
            return CLOSE_ARRAY;
        case 'error':
            throw evt.err;
        default:
            throw Error(`Unexpected ParseEvent ${evt.type}`);
    }
}
//# sourceMappingURL=index.js.map